import { jsx as _jsx } from "react/jsx-runtime";
var Card = function (_a) {
    var id = _a.id, _b = _a.className, className = _b === void 0 ? "" : _b, _c = _a.size, size = _c === void 0 ? "max-w-md" : _c, children = _a.children, _d = _a.onClick, onClick = _d === void 0 ? function () { return null; } : _d;
    return (_jsx("div", { id: id, className: "".concat(size, " shadow-md p-6 bg-white rounded-lg ").concat(className), onClick: onClick, children: children }));
};
export default Card;
